export const LOAD_LAYOUTS = 'LOAD_LAYOUTS';
export const ADD_LAYOUT = 'ADD_LAYOUT';
export const TOGGLE_IS_ACTIVE_LAYOUT = 'TOGGLE_IS_ACTIVE_LAYOUT';
export const ADD_TEXTURE = 'ADD_placeholders';
export const LOAD_LAYOUTS_BY_BOOK_ID = 'LOAD_LAYOUTS_BY_BOOK_ID';
export const REMOVE_DEFAULT_LAYOUT = 'REMOVE_DEFAULT_LAYOUT';



// WEBPACK FOOTER //
// ./src/redux/action-types/entities/layouts.js